/* esm.sh - unhead@2.1.12/dist/shared/unhead.DQc16pHI */
export * from "/*unhead@2.1.12/esnext/dist/shared/unhead.DQc16pHI.mjs";
